import {
  ClientProfileItem,
  ClientProfileSection,
} from './client-profile.model';

/**
 * One render/save leaf under a top-level profile section: stable id, optional
 * subsection heading (for nested API `sections`), and field rows.
 */
export interface ClientProfileSectionBlock {
  id: string;
  /** When set, shown as a subheading under the parent section title (e.g. "Phone numbers"). */
  subsectionTitle: string | null;
  items: ClientProfileItem[];
}

/**
 * Turns a possibly nested {@link ClientProfileSection} into flat blocks for UI and edit.
 */
export function expandClientProfileSectionToBlocks(
  section: ClientProfileSection
): ClientProfileSectionBlock[] {
  const items = section.items ?? [];
  const kids = section.sections ?? [];

  if (!kids.length) {
    return [
      {
        id: String(section.id ?? section.title),
        subsectionTitle: null,
        items,
      },
    ];
  }

  const out: ClientProfileSectionBlock[] = [];

  if (items.length > 0) {
    out.push({
      id: String(section.id ?? section.title),
      subsectionTitle: null,
      items,
    });
  }

  for (const k of kids) {
    for (const b of expandClientProfileSectionToBlocks(k)) {
      out.push({
        id: b.id,
        subsectionTitle: b.subsectionTitle ?? k.title,
        items: b.items,
      });
    }
  }

  return out;
}
